export const { REACT_APP_API_SERVER_URL } = process.env;
